export default __webpack_public_path__ + "static/media/i204jk.20b6235a.webp";